import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface mutateProps {
  projectId: string;
  planId: string;
  id: string;
}

const mutateDeleteTask = async ({
  projectId,
  planId,
  id,
}: mutateProps) => {
  return await axiosAuth.delete(`${PROJECT_API}/${projectId}/plans/${planId}/tasks/${id}`);
};

const useDeleteTaskMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteTask,
    ...queryParams,
  });

export default useDeleteTaskMutation;
